var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LoginError } from "../../types";
const ValidationErrorCode = "ValidationError";
export class ResponsiveRequestService {
    constructor(pageMethods) {
        this.pageMethods = pageMethods;
    }
    login(jwtToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.callLogin(jwtToken);
            return this.handleResponse(response);
        });
    }
    callLogin(jwtToken) {
        return new Promise((resolve, reject) => this.pageMethods.JwtTokenLogin(jwtToken, resolve, (response) => reject(new Error(response))));
    }
    loginSecondStep(twoStepToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.callLoginTwoStep(twoStepToken);
            return this.handleResponse(response);
        });
    }
    callLoginTwoStep(twoStepToken) {
        return new Promise((resolve, reject) => this.pageMethods.LoginTwoStep(twoStepToken, resolve, (response) => reject(new Error(response))));
    }
    handleResponse(response) {
        var _a;
        const result = JSON.parse(response);
        if (result instanceof Array) {
            return result;
        }
        throw new LoginError((_a = result.Error) !== null && _a !== void 0 ? _a : ValidationErrorCode, result);
    }
}
//# sourceMappingURL=ResponsiveRequestService.js.map